import { useTranslation } from 'react-i18next';
import WalkthroughPolicyCard from '../../components/settings/walkthrough-policy-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/** Settings › Pricing & quotes › Walkthrough rules: only this card, so only its reads run. */
export default function PricingWalkthroughPage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.tiles.walkthrough.title')}
      back={{ to: '/settings/pricing', label: t('settings.pricingPages.backToPricing') }}
    >
      <WalkthroughPolicyCard />
    </SettingsLeafPage>
  );
}
